import { createSelector } from 'reselect';

const selectApp = createSelector(
  (state) => state,
  (state) => state.app
);

export default createSelector(selectApp, (selectApp = {}) => selectApp.app.imageUploadCompany);
